import { CloseIcon, emptyFragment } from '@execonline-inc/execonline-ui';
import { fromEmpty } from 'maybeasy';
import { observer } from 'mobx-react';
import { T } from '../../../../../../Translations';
import ViewReport from '../../Body/ViewReport';
import DownloadCSV from '../../Body/DownloadCSV';
import ImportParticipantsStore from '../../../Store';
import { ImportedParticipants } from '../../../Store/Types';

interface Props {
  store: ImportParticipantsStore;
  importedParticipants: ImportedParticipants;
  icon: React.ReactNode;
}

function ImportMessage({ store, importedParticipants, icon }: Props) {
  const { formattingIssue, participantsOfDifferentOrg, participantsOfSameOrg, failedParticipants } =
    importedParticipants;

  return (
    <>
      {fromEmpty(participantsOfSameOrg)
        .map((participants) => (
          <p className="flex items-center justify-center text-sm mt-2 font-semibold">
            {icon}
            <T
              kind="Already Exist in your Organization ..."
              span={(content) => <span className="ml-2">{content}</span>}
              successfulCount={participants.length}
              viewImport={
                <ViewReport
                  store={store}
                  status="already-exist-in-same-org"
                  text="View all details"
                />
              }
              downloadCSV={<DownloadCSV downloadData={participantsOfSameOrg} />}
            />
          </p>
        ))
        .getOrElse(emptyFragment)}

      {fromEmpty(participantsOfDifferentOrg)
        .map((participants) => (
          <p className="flex items-center justify-center text-sm mt-2 font-semibold">
            {icon}
            <T
              kind="Already Exist but in a Different Organization ..."
              span={(content) => <span className="ml-2">{content}</span>}
              successfulCount={participants.length}
              viewImport={
                <ViewReport
                  store={store}
                  status="already-exist-in-diff-org"
                  text="View all details"
                />
              }
              downloadCSV={<DownloadCSV downloadData={participantsOfDifferentOrg} />}
            />
          </p>
        ))
        .getOrElse(emptyFragment)}

      {fromEmpty(formattingIssue)
        .map((participant) => (
          <p className="flex items-center justify-center text-sm mt-2 font-semibold">
            {icon}
            <T
              kind="Formatting Issues ..."
              span={(content) => <span className="ml-2">{content}</span>}
              successfulCount={participant.length}
              viewImport={
                <ViewReport store={store} status="formatting-issue" text="View all details" />
              }
              downloadCSV={<DownloadCSV downloadData={formattingIssue} />}
            />
          </p>
        ))
        .getOrElse(emptyFragment)}

      {fromEmpty(failedParticipants)
        .map((participants) => (
          <p className="flex items-center justify-center text-sm mt-2 font-semibold">
            <CloseIcon size="md" color="red" />
            <T
              kind="Import Failed ..."
              span={(content) => <span className="ml-2">{content}</span>}
              successfulCount={participants.length}
              viewImport={
                <ViewReport store={store} status="import-failed" text="View all details" />
              }
              downloadCSV={<DownloadCSV downloadData={failedParticipants} />}
            />
          </p>
        ))
        .getOrElse(emptyFragment)}
    </>
  );
}

export default observer(ImportMessage);
